import { Segment, Form, Image, Icon, Header } from 'semantic-ui-react';

export const ImageUploader = ({ 
  images, 
  existingImages, 
  imageError, 
  handleImageChange, 
  handleRemoveImage, 
  handleImageDelete, 
  isEdit,
  fieldValues 
}) => (
  <>
    {fieldValues.length > 0 && (
      <Segment>
        <Form.Field required={!isEdit}>
          <label>Upload Images</label>
          <Form.Input 
            type="file" 
            multiple 
            onChange={handleImageChange}
            error={imageError} 
          />
        </Form.Field>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {images.map((img, index) => (
            <div key={index}>
              <Image src={URL.createObjectURL(img)} size="small" bordered />
              <Icon name="trash" color="red" onClick={() => handleRemoveImage(index)} />
            </div>
          ))}
        </div>
      </Segment>
    )}

    {existingImages.length > 0 && fieldValues.length > 0 && (
      <Segment>
        <Header as="h5">Existing Images</Header>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {existingImages.map((img, index) => (
            <div key={index}>
              <Image src={img.imageUrl} size="small" bordered />
              <Icon name="trash" color="red" onClick={() => handleImageDelete(img.id)} />
            </div>
          ))}
        </div>
      </Segment>
    )}
  </>
);